import { PulseLoader } from 'react-spinners';

export const Loader = () => (
  <div className="has-text-centered">
    <PulseLoader size={10} />
  </div>
);
